import { createAction } from 'typesafe-actions'
import VehicleCode from '../../../entities/VehicleCode'

export const startCheckout = createAction('CMD / Checkout / start')()

export const checkoutGotVehicleCode = createAction('EVT / Checkout / got vehicle code')<{ vehicleCode: VehicleCode }>()

export const checkoutRedirect = createAction('CMD / Checkout / redirect')()
